import { useMemo } from 'react';

import { getEmailsFromContacts } from './EmailsSourceService';
import type { Email } from './ContactTypes';
import { useContacts } from './useContacts';
import type { Contact } from './ContactDataManagementTypes';

interface EmailsState {
    isLoading: boolean;
    hasError: boolean;
    emails: Email[];
}

export const useEmails = (
    filterContacts?: (contacts: Contact[]) => Contact[],
): [EmailsState, () => void] => {
    const { allEntities: contacts, isPending, error, refetch } = useContacts();
    const emails = useMemo(() => {
        const filteredContacts = filterContacts?.(contacts) ?? contacts;

        return getEmailsFromContacts(filteredContacts);
    }, [contacts, filterContacts]);

    return [
        {
            isLoading: isPending,
            hasError: !!error,
            emails,
        },
        refetch,
    ];
};
